import { QuoQuestLevel } from "../types/quest";

export const getFirstIncompleteStage = (levels: QuoQuestLevel[]) => {
  const firstUnlockedLevel = levels.find(level => level.status === "unlocked");
  if (!firstUnlockedLevel) return undefined;
  const firstUnlockedStage = firstUnlockedLevel.stages.find(
    stage => !stage.hasCleared
  );
  if (firstUnlockedStage) {
    firstUnlockedStage.levelIndex = levels.indexOf(firstUnlockedLevel);
    firstUnlockedStage.stageIndex =
      firstUnlockedLevel.stages.indexOf(firstUnlockedStage);
  }
  return firstUnlockedStage;
};
